module.exports = __webpack_public_path__ + "img/empty-search.7d209bc.jpg";